import { ConfigStore } from "../../store/modules/config";
import { CatalogStore } from "../../store/modules/catalog";
import { Watch } from "vue-property-decorator";
import { TemplatesStore } from "../../store/modules/templates";
import { getModule } from "vuex-module-decorators";
import ICatalogService from "../../services/catalog/ICatalogService";
import { container } from "@/inversify.config";
import { OperationsApi } from "../../services/api/OperationsApi";
import { DiTokens } from "../../services/diTokens";
import { ChargeData } from "../../data/chargeData";
import { OperationRequestData } from "../../data/operationRequestData";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { getCookie } from '../../utilities/cookieHelper';
import { setCookie } from '../../utilities/cookieHelper';
import IAlertService from "../../services/alert/IAlertService";
import i18n from "@/i18n";
import Vue from "vue";

/**
 *  Класс для компоненты начислений.
 */
export class ChargesVue extends Vue {

  // service:

  /**
 * Сервис каталога
 * @returns {ICatalogService}
 */
  get catalogService(): ICatalogService {
    return container.get<ICatalogService>(DiTokens.CatalogService);
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  // stores:

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище шаблонов
 * @returns {TemplatesStore}
 */
  get templatesStore(): TemplatesStore {
    return getModule(TemplatesStore, this.$store);
  }

  /**
 * Хранилище каталога
 * @returns {CatalogStore}
 */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  // data:

  /** признак диалогового окна */
  infoDialog: boolean = false;

  /** выбранное начисление */
  selectedCharge: any = {};

  /** признак загрузки */
  execLoading: boolean = false;

  /** признак видимости */
  visibilityLoading: boolean = false;

  /** признак видимости всех начисления */
  isAllChargesVisible: boolean = getCookie('isAllChargesVisible') == 'true';

  /** свитчер в диалоговом окне */
  modalSwitch: boolean = false;

  // watchers:

  /** отслеживаем закрытие диалогового окна */
  @Watch('infoDialog', { immediate: true })
  dialogToggle(val: boolean): void {
    if (!val) this.selectedCharge = {};
  }

  /** отслеживаем изменение признака видимости всех начислений */
  @Watch('isAllChargesVisible')
  isAllChargesVisibleChange(val: boolean): void {
    setCookie('isAllChargesVisible', val.toString());
  }

  // computed:

  /**
 * Начисления
 * @returns {Array<ChargeData>} - массив начислений
 */
  get charges(): Array<ChargeData> {
    return this.catalogStore.charges;
  }

  /**
 * Признак загрузки начислений
 * @returns {boolean} - Признак загрузки начислений
 */
  get loading(): boolean {
    return this.catalogStore.chargesLoading;
  }

  // methods:

  /**
 * Инициализация
 * @param {boolean} flag - признак 
 */
  async init(flag: boolean = false): Promise<void> {
    if (!this.charges || this.charges.length === 0 || flag) {
      await this.catalogStore.fetchCharges(this.isAllChargesVisible);
    }
  }

  /** изменение видимости начислений */
  async setChargeVisibility(): Promise<void> {
    if (this.selectedCharge) {
      this.visibilityLoading = true;
      let ord: OperationRequestData = new OperationRequestData();
      ord.respondentCode = this.configStore.apiData.OperationCodeOfSetChargeVisibility;
      ord.setProperty(
        "chargeId",
        this.selectedCharge.Id,
        DeclarationPropertiesTypes.String
      );
      ord.setProperty(
        "hidden",
        !this.modalSwitch,
        DeclarationPropertiesTypes.Boolean
      );
      try {
        ord = await OperationsApi.executeOperationSendAsync(ord);
        if (ord) {
          await this.catalogStore.fetchCharges(this.isAllChargesVisible);
          this.selectedCharge.Hidden = !this.modalSwitch;
        }
      } catch (e) {

      } finally {
        this.visibilityLoading = false;
      }
    }
  }

  /**
 * показать диалоговое окно
 * @param {ChargeData} selectedCharge - выбранное начисление 
 */
  showDialog(selectedCharge: ChargeData) {
    this.infoDialog = true;
    this.selectedCharge = selectedCharge;
    this.modalSwitch = !this.selectedCharge.Hidden;
    if(this.selectedCharge.HasActiveDiscount) {
      this.alertService.info(i18n.t("main.charges.infoDiscount").toString());
    }
  }

  /** перейти к платежу */
  async toPayment(): Promise<void> {
    try {
      this.execLoading = true;
      let ord: OperationRequestData = new OperationRequestData();
      ord.respondentCode =
        this.configStore.apiData.OperationCodeOfFillOperationFromCharge;
      ord.setProperty(
        "charge",
        this.selectedCharge.Data,
        DeclarationPropertiesTypes.String
      );
      const resp: any = await OperationsApi.operationSendAsync('WebClient/FillList', ord);

      const addInitData: Array<string> = [];

      if (resp.data && resp.data.Data && resp.data.Data.Properties) {
        for (const key in resp.data.Data.Properties) {
          const item: any = resp.data.Data.Properties[key];
          if (key != "charge") {
            addInitData.push(`${key}=${item}`);
          }
        }
      }

      // .forEach((k: string) => {
      //   if (k != "charge")
      //     addInitData.push(`${k}=${ord.getPropertyValue(k)}`);
      // });

      this.$router.push(
        `/operation/0/${
          this.configStore.apiData.OperationCodeOfToExt
        }?${addInitData.join("&")}`
      );

      this.execLoading = false;
    } catch (e) {
      this.alertService.error(e.message);
    }
  }

}
